// extracted by mini-css-extract-plugin
export default {"v-application":"Checkbox_v-application_fCrCg","text-h1":"Checkbox_text-h1_PXQcd","text-h2":"Checkbox_text-h2_gwr1H","checkbox":"Checkbox_checkbox_skYqx"};